import { render, staticRenderFns } from "./EmployeePhoneNo2Field.vue?vue&type=template&id=79cabe1d&"
import script from "./EmployeePhoneNo2Field.vue?vue&type=script&lang=js&"
export * from "./EmployeePhoneNo2Field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79cabe1d')) {
      api.createRecord('79cabe1d', component.options)
    } else {
      api.reload('79cabe1d', component.options)
    }
    module.hot.accept("./EmployeePhoneNo2Field.vue?vue&type=template&id=79cabe1d&", function () {
      api.rerender('79cabe1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeePhoneNo2Field.vue"
export default component.exports